// libs
import React, { memo } from 'react';
import { withDataFetching } from 'shared/helpers/dataFetching';

import AuthModalWrapper from 'shared/components/AuthModal/AuthModalWrapper';

// global components
import ConfirmRedirectProvider from 'shared/components/ConfirmRedirect/Provider';

//components
import MyAccount from 'shared/components/MyAccount';

import {
  setHeaderOptions as _setHeaderOptions,
  resetHeaderOptions as _resetHeaderOptions,
  hideFooter as _hideFooter,
} from 'shared/store/app/actions';

interface IMyAccountProps {
  isUserFetching: boolean;
  isLoggedIn: boolean;
  setHeaderOptions: typeof _setHeaderOptions;
  resetHeaderOptions: typeof _resetHeaderOptions;
  hideFooter: typeof _hideFooter;
}

function MyAccountPage() {
  return (
    <ConfirmRedirectProvider>
      <AuthModalWrapper>
        <MyAccount />
      </AuthModalWrapper>
    </ConfirmRedirectProvider>
  );
}

const setHeaders = async ({ setHeaderOptions, hideFooter }: IMyAccountProps) => {
  hideFooter();
  setHeaderOptions({
    showDiscount: false,
    showHamburger: false,
    showLogo: true,
    showSearch: false,
    showBack: true,
    showBottomBorder: true,
  });
};

export default withDataFetching(setHeaders)(memo(MyAccountPage));
